import React from 'react';
//import SingleMenu from '../../../feature-module/components/SingleMenu/singlemenu';
import PropTypes from 'prop-types';
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import '../../../feature-module/pages/menus/MyButton.css';
// import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { base_api_url } from "../../../environment.jsx";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const AddOrder = ({article, menu, show, onHide, onOrderSuccess}) => {
    // const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [DetailOrder, setDetailOrder] = useState(null);
    const MySwal = withReactContent(Swal);
    const devise = JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.devise;

    //pour recuprer les elements du formulaire
    const [formData, setFormData] = useState({
        "commentaire": " ",
        "prix_unitaire": 0,
        "quantite": 1,
    });

    useEffect(() => {
    if (article) {
        setFormData((prev) => ({
        ...prev,
        prix_unitaire: article.prix_unitaire,
        }));
    }
    }, [article]);
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "quantite" ? Number(value) : value,
        }));
    };

    const handleSubmit = async (e, article) => {
        e.preventDefault(); // éviter le rechargement de la page
        setLoading(true);
        const reference = JSON.parse(sessionStorage.getItem("client"))?.reference;
        try {
            const response = await axios.post(`${base_api_url}api/detailscmd/${article.id_article}/${menu?.id_menu}/${reference}`, formData)
            console.log("Réponse de l'api :", response.data);
            
            // Handle successful responses (200, 201)
            if (response.status === 200 || response.status === 201) {
                setDetailOrder(response.data);

                // Fetch updated order details
                await fetchOrderDetails(reference);
                
                // Show success notification
                MySwal.fire({
                    icon: "success",
                    // title: "Article ajouté !",
                    text: "Votre article a bien été ajouté au panier !",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: {
                        popup: "pixel-toast",
                    },
                });
                
                onHide(); // Close modal and stay on homemenu
            }
            
        } catch (error) {
            console.error("Error adding article to order:", error);
            
//             let errorTitle = "Erreur d'ajout";
            let errorMessage = "Impossible d'ajouter l'article au panier.";
            
            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;
                
                switch (status) {
                    case 400:
//                         errorTitle = "Données invalides";
                        if (errorData?.message?.includes("quantite")) {
                            errorMessage = "La quantité doit être un nombre valide supérieur à 0.";
                        } else {
                            errorMessage = errorData?.message || "Les données saisies ne sont pas valides.";
                        }
                        break;
                        
                    case 401:
//                         errorTitle = "Session expirée";
                        errorMessage = "Votre session a expiré. Veuillez rafraîchir la page.";
                        break;
                        
                    case 404:
//                         errorTitle = "Article introuvable";
                        errorMessage = "Cet article n'est plus disponible ou n'existe pas dans ce menu.";
                        break;
                        
                    case 409:
//                         errorTitle = "Article déjà dans le panier";
                        errorMessage = "Cet article est déjà dans votre panier. Modifiez la quantité depuis le panier.";
                        break;
                        
                    case 422:
//                         errorTitle = "Commande invalide";
                        errorMessage = errorData?.message || "Impossible d'ajouter cet article à votre commande.";
                        break;
                        
                    case 500:
//                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer.";
                        break;
                        
                    case 503:
//                         errorTitle = "Service indisponible";
                        errorMessage = "Le service de commande est temporairement indisponible.";
                        break;
                        
                    default:
//                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || "Une erreur inattendue s'est produite.";
                }
            } else if (error.request) {
//                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
            }
            
            // Show error notification
            MySwal.fire({
                icon: "error",
                // title: errorTitle,
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
        }
        finally {
            setLoading(false);
        }
    };

    // Fetch order details to get total quantity
    const fetchOrderDetails = async (reference) => {
        try {
            const response = await axios.get(`${base_api_url}api/commande/${reference}`);
            
            // Handle successful responses (200, 201)
            if (response.status === 200 || response.status === 201) {
                console.log("Order details:", response.data);
                
                // Calculate total quantity from all order details
                const totalQuantity = response.data.Details?.reduce((total, detail) => {
                    return total + (detail.quantite || 0);
                }, 0) || 0;
                
                // Call parent callback with the total quantity
                if (onOrderSuccess) {
                    onOrderSuccess(totalQuantity);
                }
            }
            
        } catch (error) {
            console.error("Error fetching order details:", error);
            
//             let errorTitle = "Erreur de mise à jour du panier";
            let errorMessage = "Impossible de mettre à jour la quantité du panier.";
            let showError = true;
            
            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;
                
                switch (status) {
                    case 404:
                        // Order not found - this might be normal, set quantity to 0 silently
                        console.log("Order not found during fetch - this might be expected");
                        if (onOrderSuccess) {
                            onOrderSuccess(0);
                        }
                        showError = false;
                        break;
                        
                    case 401:
//                         errorTitle = "Session expirée";
                        errorMessage = "Votre session a expiré. Veuillez rafraîchir la page.";
                        break;
                        
                    case 403:
//                         errorTitle = "Accès refusé";
                        errorMessage = "Vous n'avez pas accès à cette commande.";
                        break;
                        
                    case 500:
//                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur lors de la mise à jour du panier.";
                        break;
                        
                    case 503:
//                         errorTitle = "Service indisponible";
                        errorMessage = "Le service est temporairement indisponible.";
                        break;
                        
                    default:
//                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors de la mise à jour du panier.";
                }
            } else if (error.request) {
//                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur pour mettre à jour le panier.";
            }
            
            // Show error notification only for actual errors
            if (showError) {
                MySwal.fire({
                    icon: "warning",
                    // title: errorTitle,
                    text: errorMessage,
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: {
                        popup: "pixel-toast",
                    },
                });
            }
            
            // Set default quantity on error (except for 404 which is handled above)
            if (error.response?.status !== 404 && onOrderSuccess) {
                onOrderSuccess(0);
            }
        }
    };

    console.log("le detail de la commande", DetailOrder)
    console.log("MODAL", show, article);
    if (!show || !article) return null;

    return (
        <>
            <div
                className="modal show fade"
                tabIndex="-1"
                aria-modal="true"
                role="dialog"
                style={{
                    display: "block",
                    background: "rgba(0,0,0,0.45)",
                    zIndex: 9999,
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    overflow: "hidden",
                }}
            >
                <div
                    className="modal-dialog"
                    style={{
                        position: "fixed",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: "100vw",            // full viewport width
                        padding: 0,                // no side gap to ensure true full width
                        boxSizing: "border-box",
                        margin: 0,
                        zIndex: 10000,
                    }}
                >
                    <div
                        className="modal-content"
                        style={{
                            width: "100vw",           // ensure content spans full viewport width
                            margin: 0,
                            borderRadius: 16,
                            padding: 20,
                            background: "#fff",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                            position: "relative",
                            overflow: "hidden",
                        }}
                    >
                        {/* close button */}
                        <button
                            type="button"
                            aria-label="Fermer"
                            onClick={onHide}
                            style={{
                                position: "absolute",
                                top: 12,
                                right: 12,
                                background: "transparent",
                                border: "none",
                                fontSize: 20,
                                cursor: "pointer",
                                color: "#333",
                            }}
                        >
                            ×
                        </button>

                        {/* top image (centered) */}
                        <div style={{ display: "flex", justifyContent: "center", marginTop: 6 }}>
                            <div
                                style={{
                                    width: 128,
                                    height: 127,
                                    borderRadius: 12,
                                    overflow: "hidden",
                                    boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                                }}
                            >
                                <ImageWithBasePath
                                    src={article.image_url}
                                    alt={article.nom}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            </div>
                        </div>

                        {/* title + rating */}
                        <div style={{ marginTop: 12, textAlign: "left", padding: "0 6px" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <h3 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: "#222" }}>{article.nom}</h3>
                                <div style={{ display: "flex", alignItems: "center", gap: 6, color: "#666", fontSize: 14 }}>
                                    <span style={{ color: "#ff9900", fontSize: 16 }}>★</span>
                                    <span>({article.note ?? article.rating ?? "4,6"})</span>
                                </div>
                            </div>

                            <p style={{ marginTop: 8, marginBottom: 6, color: "#777", fontSize: 14, lineHeight: 1.3 }}>
                                {article.description}
                            </p>
                        </div>

                        {/* quantity control */}
                        <div style={{ display: "flex", marginTop: 12 }}>
                            <div
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    background: "#f4f4f6",
                                    borderRadius: 999,
                                    padding: "6px 10px",
                                    gap: 10,
                                }}
                            >
                                <button
                                    type="button"
                                    onClick={() => setFormData((p) => ({ ...p, quantite: Math.max(1, (p.quantite || 1) - 1) }))}
                                    style={{
                                        width: 34,
                                        height: 34,
                                        borderRadius: "50%",
                                        border: "none",
                                        background: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                        cursor: "pointer",
                                        fontSize: 20,
                                        color: "#333",
                                    }}
                                >
                                    −
                                </button>

                                <input
                                    name="quantite"
                                    type="number"
                                    value={formData.quantite}
                                    onChange={handleChange}
                                    min={1}
                                    onBlur={() => { if (!formData.quantite || formData.quantite < 1) setFormData(p => ({ ...p, quantite: 1 })); }}
                                    style={{
                                        width: 44,
                                        textAlign: "center",
                                        fontWeight: 600,
                                        border: "none",
                                        background: "transparent",
                                        outline: "none",
                                        fontSize: 16,
                                    }}
                                />

                                <button
                                    type="button"
                                    onClick={() => setFormData((p) => ({ ...p, quantite: (p.quantite || 1) + 1 }))}
                                    style={{
                                        width: 34,
                                        height: 34,
                                        borderRadius: "50%",
                                        border: "none",
                                        background: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                        cursor: "pointer",
                                        fontSize: 18,
                                        color: "#333",
                                    }}
                                >
                                    +
                                </button>
                            </div>
                        </div>

                        {/* submit area */}
                        <form onSubmit={(e) => handleSubmit(e, article)}>
                            <div style={{ marginTop: 18 }}>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        background: "#FDE7DF",
                                        border: "none",
                                        padding: "12px 16px",
                                        borderRadius: 12,
                                        color: "#E7592C",
                                        fontWeight: 700,
                                        fontSize: 16,
                                        cursor: "pointer",
                                    }}
                                >
                                    <span>Ajouter à ma commande</span>
                                    <span style={{ background: "transparent", color: "#E7592C", fontWeight: 700 }}>
                                        {article.prix_unitaire} {devise}
                                    </span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )

} 
AddOrder.propTypes = { 
  article: PropTypes.object.isRequired, 
  menu: PropTypes.object.isRequired,
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onOrderSuccess: PropTypes.func
};

export default AddOrder;